import React from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"

import {NavigationList, NavigationListLink} from "~/components/"
import {useTranslation, withTranslation} from "react-i18next"

const articleIcon = require("~/icons/article_16_white.svg")
const homeIcon = require("~/icons/home_16_white.svg")
const productIcon = require("~/icons/product_16_white.svg")
const warehouseIcon = require("~/icons/warehouse_16_white.svg")
const destinationIcon = require("~/icons/destination_16_white.svg")
const transactionsIcon = require("~/icons/transactions_16_white.svg")

const TenantNavigationList = ({settings, user, children}) => {
  const {t} = useTranslation()
  return (
    <NavigationList>
      <NavigationListLink exact to="/" icon={homeIcon}>
        {t("navigationItems.home")}
      </NavigationListLink>

      <NavigationListLink to="/products" icon={productIcon}>
        {t("navigationItems.products")}
      </NavigationListLink>

      <NavigationListLink to="/articles" icon={articleIcon}>
        {t("navigationItems.articles")}
      </NavigationListLink>

      <NavigationListLink to="/warehouse" icon={warehouseIcon}>
        {t("navigationItems.warehouse")}
      </NavigationListLink>

      <NavigationListLink to="/transactions" icon={transactionsIcon}>
        {t("navigationItems.transactions")}
      </NavigationListLink>

      <NavigationListLink to="/destinations" icon={destinationIcon}>
        {t("navigationItems.destinations")}
      </NavigationListLink>
      {children}
      <NavigationListLink
        to={"/inventories/" + user.subdomain}
        icon={destinationIcon}
      >
        {t("navigationItems.inventories")}
      </NavigationListLink>
    </NavigationList>
  )
}

TenantNavigationList.propTypes = {
  settings: PropTypes.object.isRequired
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  return {settings, user}
}

export default withTranslation("navigationItems")(
  withRouter(connect(mapStateToProps)(TenantNavigationList))
)



// WEBPACK FOOTER //
// ./src/components/navigations/TenantNavigationList.js